import { Loader } from "@mantine/core";
import { FC, useContext } from "react";
import { AppContext } from "src/api/AppContext";
import { UserRole } from "src/generated/graphql";
import EmployeeOnboarding from "./screens/EmployeeOnboarding";
import ClientOnboarding from "./screens/ClientOnboarding";

interface Props {
  children?: React.ReactNode;
}

const Onboarding: FC<Props> = ({ children }) => {
  const { currentUser } = useContext(AppContext);
  if (currentUser?.role === UserRole.Employee) {
    return <EmployeeOnboarding />;
  } else if (currentUser?.role === UserRole.Client) {
    return <ClientOnboarding />;
  }
  return <Loader />;
};

export default Onboarding;
